define( 'hayak-popup',[ 'jquery' ],
function( $ ) {

	'use strict';

	var hayakPopup = {};

	function open_unyco_popup(event){
		var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left,
				dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top,
				url = $(event.currentTarget).attr('href'),
				width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
				height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
				left = ((width / 2) - (350 / 2)) + dualScreenLeft,
				top = ((height / 2) - (500 / 2)) + dualScreenTop,
				unyco_popup_window = this.unyco_popup_window;

		event.preventDefault();

		if (unyco_popup_window==null || unyco_popup_window.closed){
			this.unyco_popup_window = window.open(url, 'hayakPopUp','width=400,height=600,scrollbar=no,location=no,toolbar=no,resizable=false,left='+left+',top='+top);
		}else{
			this.unyco_popup_window.focus();
		}
	}

	hayakPopup.init = function() {
		$( '.js-hayak-popup' ).on( 'click', $.proxy( open_unyco_popup, this )) ;
	};

	return hayakPopup;
} );

